module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/logo_black-b28558e64447a2bd369f53c986ec3bb9.svg&quot;;"